<template>
    <div class="container edit-flight">
        <div class="box">
            <div class="level">
                <div class="level-left">
                    <div class="level-item">
                        <div class="field">
                            <router-link :to="{ name: 'Schedule', params : {date:this.SearchDate }}" active-class="is-active">
                                <button class="button is-info">
                      <span class="icon">
                    <i class="fas fa-long-arrow-alt-left"></i></span>
                                    <span>Back To Schedule</span>
                                </button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="columns">
                <div class="column">
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Carrier</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.carrier">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Flight Number</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.fno">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Aircraft Registration</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.acreg">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Leg Type</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
<!--                                    <input class="input" type="text" v-model="selectedFlight.leG_NO" disabled>-->
                                </div>
                                <div class="select">
                                    <select v-model="selectedFlight.leG_TYPE" style = "width: 250px">
                                        <option value="P">Position</option>
                                        <option value="C">Chart</option>
                                        <option value="J">Scheduled</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Leg State</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
<!--                                    <input class="input" type="text" v-model="selectedFlight.leG_NO" disabled>-->
                                    <div class="select">
                                        <select v-model="selectedFlight.leG_STATE" style = "width: 250px">
                                            <option value="ARR">ARR</option>
                                            <option value="DEP">DEP</option>
                                            <option value="SKD">EKD</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">AC Owner</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.aC_OWNER">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Schedule Departure</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.sdep">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Schedule Arrival</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.sarr">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Actual Departure</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.adep">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Actual Arrival</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.aarr">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Schedule Departure Date</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control" >
                                    <datepicker v-model="selectedFlight.std"
                                                :config="{ dateFormat:'Y-m-d H:i', enableTime:true,static: true,wrap:true }">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Schedule Arrival Date</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <datepicker v-model="selectedFlight.sta"
                                                :config="{ dateFormat:'Y-m-d H:i', enableTime:true,static: true,wrap:true }">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Actual Departure Date</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <datepicker v-model="selectedFlight.atd"
                                                :config="{ dateFormat:'Y-m-d H:i', enableTime:true,static: true,wrap:true }">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Actual Arrival Date</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <datepicker v-model="selectedFlight.ata"
                                                :config="{ dateFormat:'Y-m-d H:i', enableTime:true,static: true,wrap:true }">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Captain 1</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.cP1">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Captain 2</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.cP2">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Captain 3</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.cP3">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Cabin List</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.cabinList">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>

                        <input type="text" v-model="selectedFlight.manuelUpdate" hidden>
                    </div>
                </div>
            </div>
        </div>

        <div class="box">
            <div class="field animate__animated animate__fadeInDown">
                <div class="control">
                    <button class="button" :class="{'is-link' : !isLoading ,'is-success' : isLoading}" type="button"
                            @click="createFlight(selectedFlight)" :disabled="isLoading">
                            <span class="icon is-small">
                            <font-awesome-icon :icon="isLoading ? 'spinner' : 'check'" :spin="isLoading"/>
                            </span>
                        <span>Save</span>
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import {loadingMixin} from "../../utils/mixins";
    import Datepicker from "vue-bulma-datepicker";
    import EditFlightService from "../../services/editFlight.service";
    import {mapState} from "vuex";
    export default {
        name: "CreateFlight",
        mixins: [loadingMixin],
        data: function () {
            return {
                docState: false,
                id: this.$route.params.id,
                SearchDate : this.$route.params.SearchDate,
                selectedFlight: {
                    fKey1: "",
                    leG_NO: 0,
                    std: new Date(this.$route.params.SearchDate).toISOString().slice(0, 10),
                    sta: new Date(this.$route.params.SearchDate).toISOString().slice(0, 10),
                    atd: new Date(this.$route.params.SearchDate).toISOString().slice(0, 10),
                    ata: new Date(this.$route.params.SearchDate).toISOString().slice(0, 10),
                    carrier: "",
                    fno: "",
                    suffix: "",
                    sdep: "",
                    sarr: "",
                    adep: "",
                    aarr: "",
                    acreg: "",
                    leG_TYPE: "",
                    leG_STATE: "",
                    aC_OWNER: "",
                    cP1: "",
                    cP2: "",
                    cP3: "",
                    cabinList : "",
                    manuelUpdate: "true",
                    whoDidManual: "",
                },
            }
        },
        components: {
            Datepicker,
        },
        async created() {

        },
        methods: {

            async createFlight(form) {
                this.showLoading();
                var result;
                try {

                    form.whoDidManual = this.user.full_name;
                    result = await EditFlightService.createFlightForm(form);

                    var msg =result.toString().substring(0,1);
                    console.log(msg + " "+ result);
                    if (msg ==1)
                    {
                        this.$notify({title: "Success", text: result, type: "success"});
                    }
                    else
                    {
                        this.$notify({title: "Warning", text: result, type: "warning"});
                    }

                    return result.data;
                } catch (e) {
                    this.$notify({title: "Error", text: "Error on createFlightForm function e: " + e.message, type: "error"});
                } finally {
                    this.hideLoading();
                }
            },




        },
        computed : {
            ...mapState("auth",["user"]),



        }
    }
</script>

<style scoped>

</style>
